import { render, staticRenderFns } from "./BusinessDocumentFlow.vue?vue&type=template&id=76ac274e&scoped=true&"
import script from "./BusinessDocumentFlow.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac274e",
  null
  
)

export default component.exports